<template>
    <section-jumbo
        v-if="item"
        color="bg-zinc-950"
        class="section-home-jumbo"
        padding="py-32 sm:py-36 lg:py-40 xl:py-48 2xl:py-56"
        :video="item.video"
        videoOpacity="opacity-40"
        videoPosition="object-[50%_20%]"
        :image="item.image"
        imageOpacity="opacity-40"
        imagePosition="object-top"
        :heading="item.heading"
        headingColor="text-white"
        :content="item.content"
        contentColor="text-zinc-100"
    >
        <template v-slot:custom>
            <div class="mt-8 flex flex-row space-x-1">
                <button-primary v-if="items.length > 1" buttonText="<" :buttonClick="decrementItem"></button-primary>
                <button-primary
                    :buttonUrl="item.url"
                    :buttonRoute="item.route"
                    :buttonText="item.action"
                ></button-primary>
                <button-primary v-if="items.length > 1" buttonText=">" :buttonClick="incrementItem"></button-primary>
            </div>
        </template>
    </section-jumbo>
</template>

<script setup>
const props = defineProps({
    activeStreams: {
        required: true,
        type: Array,
        default() {
            return [];
        },
    },
    upcomingStreams: {
        required: true,
        type: Array,
        default() {
            return [];
        },
    },
});

const index = useState('home-jumbo-index', () => 0);

const items = computed(() => {
    const $config = useRuntimeConfig().public;
    const result = [];
    props.activeStreams.forEach((stream) => {
        result.push({
            route: stream.stream_route,
            action: 'Watch Now',
            image: stream.stream_image_url,
            heading: stream.stream_title,
            content: '<p>' + stream.stream_time_from_now + '</p>',
        });
    });
    props.upcomingStreams.forEach((stream) => {
        result.push({
            route: stream.stream_route,
            action: 'Event Details',
            image: stream.stream_image_url,
            heading: stream.stream_title,
            content: '<p>' + stream.stream_time_from_now + '</p>',
        });
    });
    result.push({
        route: '/classes',
        image: $config.images + 'west-coast-swing-classes.jpg',
        heading: 'Learn West Coast Swing!',
        content: '<p>It all starts with a beginner class</p>',
        action: 'Browse Classes',
    });
    return result;
});

const item = computed(() => {
    return items.value ? items.value[index.value] : null;
});

function incrementItem() {
    index.value = index.value >= items.value.length - 1 ? 0 : index.value + 1;
}

function decrementItem() {
    index.value = index.value <= 0 ? items.value.length - 1 : index.value - 1;
}
</script>
